import { ReactElement, useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import { isAuthenticated } from '../utils/auth'
import { useLogout } from '@/shared/hooks'

interface ProtectedRouteProps {
  children: ReactElement
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const logout = useLogout()

  useEffect(() => {
    if (!isAuthenticated()) {
      logout()
      return
    }

    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === 'token' && !e.newValue) {
        logout()
      }
    }

    window.addEventListener('storage', handleStorageChange)

    const intervalId = setInterval(() => {
      if (!isAuthenticated()) {
        logout()
      }
    }, 5000)

    return () => {
      window.removeEventListener('storage', handleStorageChange)
      clearInterval(intervalId)
    }
  }, [logout])

  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />
  }

  return children
}
